<template>
  <div v-if="show" class="scan" aria-hidden="true" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

const props = withDefaults(
  defineProps<{
    /** Skip the scan if it has already fired this session (key per screen). */
    sessionKey?: string;
  }>(),
  { sessionKey: "scan:triage" },
);

const show = ref(false);

onMounted(() => {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced) return;
  try {
    if (sessionStorage.getItem(props.sessionKey) === "1") return;
    sessionStorage.setItem(props.sessionKey, "1");
  } catch {
    // sessionStorage unavailable — fall through and play the scan once.
  }
  show.value = true;
  // Auto-remove a hair after --speed-scan (700ms) so the overlay
  // doesn't sit dormant in front of pointer-events for any longer than it
  // needs to.
  window.setTimeout(() => { show.value = false; }, 800);
});
</script>

<style scoped>
.scan {
  position: fixed;
  left: 0; right: 0; top: 0;
  height: 100vh;
  pointer-events: none;
  z-index: 60;
  overflow: hidden;
}
.scan::before {
  content: "";
  position: absolute;
  left: 0; right: 0; top: -2px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--red) 30%, var(--red) 70%, transparent);
  box-shadow: 0 0 24px 3px color-mix(in srgb, var(--red) 50%, transparent);
  animation: scanDown var(--speed-scan) var(--ease-scan) forwards;
}
@keyframes scanDown {
  0% { transform: translateY(0); opacity: 0; }
  8% { opacity: 1; }
  92% { opacity: 1; }
  100% { transform: translateY(110vh); opacity: 0; }
}
</style>
